import { createListenerMiddleware } from '@reduxjs/toolkit';
import { pickDevice } from 'console/redux/main-actions';
import { activeMapDashboard, exitMapDashboard } from 'pages/dashboard.map/model/store';
import { set_ui_settings } from 'console/redux/settings-actions';
import { deActivateZTHDashboard } from 'console/dashboards/zth/actions';
import { leaveFromDashboard } from 'console/dashboards/z3k/actions';
export const listenerMiddlewareMapDashboard = createListenerMiddleware();
listenerMiddlewareMapDashboard.startListening({
    actionCreator: activeMapDashboard,
    effect: (action, listenerApi) => {
        // @ts-ignore
        listenerApi.dispatch(pickDevice(null));
        // @ts-ignore
        listenerApi.dispatch(set_ui_settings({ map_dashboard_active: true }));
        // @ts-ignore
        listenerApi.dispatch(deActivateZTHDashboard());
        // @ts-ignore
        listenerApi.dispatch(leaveFromDashboard());
    },
});
listenerMiddlewareMapDashboard.startListening({
    actionCreator: exitMapDashboard,
    effect: (action, listenerApi) => {
        // @ts-ignore
        listenerApi.dispatch(set_ui_settings({ map_dashboard_active: false }));
    },
});
